import { Language } from "@livechat/design-system-icons";

import { IFilterConfig, IFilterLabelValue } from "../interfaces";

export const languageFilterConfig: IFilterConfig = {
  title: "Language",
  multiple: true,
  icon: Language,
  getFilterLabelValues(filterValues: string[] | null, labels: Record<string, string>): IFilterLabelValue[] {
    if (filterValues === null) {
      return [];
    }
    return filterValues?.map(lang => ({
      key: lang,
      label: lang === "none" ? "Not detected" : `${labels[lang]} (${lang.toLocaleUpperCase()})`,
    }));
  },
};
